import { useEffect, useState } from 'react';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { useGetDataSources } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSources';
import { extractDataSourceOptions } from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/utils/dataSourceSelectDropdownUtils';
import DataPassingPanelHeaderInputSkeleton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderInputSkeleton';
import DataPassingPanelHeaderEditAvailableButton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderEditAvailableButton';
import { DEFAULT_ALLOWED_DATA_SOURCES } from 'automation-ui-formula-editor/data-sources/utils/isDataSourceAllowListed';
import { getFilterTargetType } from 'automation-ui-formula-editor/data-passing-panel/utils/getFilterTargetType';
import { jsx as _jsx } from "react/jsx-runtime";
const DataPassingPanelHeaderSelectDataSource = ({
  isAddDataSourceBtnVisible,
  isEmbedded,
  isFirstAction,
  lastAddedEditedDataSource,
  onChangeSelectedDataSource,
  openFetchObjectPanel,
  dataSourceAllowList,
  selectedDataSourcePrefix = ENROLLED_OBJECT
}) => {
  const defaultDataSources = new Set(isEmbedded ? [ENROLLED_OBJECT] : dataSourceAllowList !== null && dataSourceAllowList !== void 0 ? dataSourceAllowList : DEFAULT_ALLOWED_DATA_SOURCES);
  const [dataSourcesToRetrieve, setDataSourcesToRetrieve] = useState(defaultDataSources.add(selectedDataSourcePrefix));
  const dataSourcePrefixReqs = Array.from(dataSourcesToRetrieve).map(prefix => {
    return {
      prefix
    };
  });
  const {
    loading,
    error,
    data: dataSourcesData
  } = useGetDataSources(dataSourcePrefixReqs);
  const [isLoadingChildren, setIsLoadingChildren] = useState(true);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const dataSourceOptions = extractDataSourceOptions({
    data: dataSourcesData,
    isEmbedded,
    isFirstAction,
    dataSourceAllowList: Array.from(defaultDataSources)
  });
  useEffect(() => setDataSourcesToRetrieve(defaultDataSources.add(selectedDataSourcePrefix)),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedDataSourcePrefix]);
  useEffect(() => {
    if (!lastAddedEditedDataSource || loading || isLoadingChildren || !dataSourcesData) {
      return;
    }
    if (dataSourcesData.has(lastAddedEditedDataSource)) {
      onChangeSelectedDataSource(lastAddedEditedDataSource);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastAddedEditedDataSource, loading, isLoadingChildren]);
  useEffect(() => {
    if (loading) {
      return;
    }
    if (error || !dataSourcesData) {
      setIsLoadingChildren(false);
      return;
    }

    // get the next level of fetched objects and enrollment events
    const childrenDataSourcesPrefixReqs = dataSourcePrefixReqs.flatMap(prefixReq => {
      var _dataSourcesData$get$, _dataSourcesData$get;
      let children = (_dataSourcesData$get$ = (_dataSourcesData$get = dataSourcesData.get(prefixReq.prefix)) === null || _dataSourcesData$get === void 0 ? void 0 : _dataSourcesData$get.dataSourceDefinition.children) !== null && _dataSourcesData$get$ !== void 0 ? _dataSourcesData$get$ : [];
      children = children.filter(childDataSource => {
        const isSupportedConnectionType = childDataSource.connectionType === DataSourceType.FETCHED_OBJECT || childDataSource.connectionType === DataSourceType.ENROLLMENT_EVENT;
        const isSingleRecordDataSource = getFilterTargetType(childDataSource.metadata) === 'ONE';
        return isSupportedConnectionType && isSingleRecordDataSource;
      });
      return children.map(childDataSource => childDataSource.toDataSource);
    });
    setDataSourcesToRetrieve(prevState => {
      const newState = new Set([...prevState, ...childrenDataSourcesPrefixReqs]);
      if (prevState.size === newState.size) {
        setIsLoadingChildren(false);
      }
      return newState;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSourcesData, loading]);
  const handleOnSelectedOptionChange = event => {
    onChangeSelectedDataSource(event.target.value.value);
  };
  const handleOnOpenFetchObjectPanel = () => {
    setIsSelectOpen(false);
    openFetchObjectPanel();
  };
  if (loading || isLoadingChildren) {
    return /*#__PURE__*/_jsx(DataPassingPanelHeaderInputSkeleton, {
      "data-test-id": "data-panel-select-data-source-skeleton"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(UISelect, {
      className: "m-bottom-1",
      "data-test-id": "data-panel-select-data-source-error",
      onSelectedOptionChange: handleOnSelectedOptionChange,
      options: [{
        text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.error-recovery-data-source'),
        value: ENROLLED_OBJECT
      }],
      value: selectedDataSourcePrefix
    });
  }
  return /*#__PURE__*/_jsx(UISelect, {
    className: "m-bottom-1",
    "data-test-id": "data-panel-select-data-source",
    onSelectedOptionChange: handleOnSelectedOptionChange,
    options: dataSourceOptions,
    value: selectedDataSourcePrefix,
    dropdownFooter: isAddDataSourceBtnVisible ? /*#__PURE__*/_jsx(DataPassingPanelHeaderEditAvailableButton, {
      openFetchObjectPanel: handleOnOpenFetchObjectPanel
    }) : null,
    open: isSelectOpen,
    onOpenChange: event => setIsSelectOpen(event.target.value)
  });
};
export default DataPassingPanelHeaderSelectDataSource;